// src/content/pricing.js
// Public price list, built from Services/products.js so it can't drift from
// what checkout charges. Used by Screens/Pricing.jsx and scripts/prerender.mjs.
import { PRODUCTS, formatUsd, formatNaira } from "../Services/products.js";

const row = (name, productId, note) => ({
  name,
  note,
  usd: formatUsd(PRODUCTS[productId].priceUsdCents),
  ngn: formatNaira(PRODUCTS[productId].priceNgn),
});

export const PRICING_GROUPS = [
  {
    heading: "Coins",
    description: "Coins are used inside NameIt!, for example to add player seats to a room.",
    rows: [
      row("100 coins", "coins_100"),
      row("280 coins", "coins_280"),
      row("500 coins", "coins_500"),
      row("1000 coins", "coins_1000"),
    ],
  },
  {
    heading: "Extra player seats",
    description: "More players in one room for its session. A custom number of seats is priced as a mix of these bundles.",
    rows: [row("+1 seat", "seats_1"), row("+3 seats", "seats_3"), row("+5 seats", "seats_5")],
  },
  {
    heading: "NameIt! Pro",
    description: "Larger rooms, unlimited rooms, a monthly coin bonus, and extra hints and dictionary checks.",
    rows: [
      row("Pro — monthly subscription", "pro_monthly", "Naira payments renew every month until you cancel."),
      row("Pro — 1-month pass", "pro_onetime", "One payment for 1 month. Does not renew."),
    ],
  },
];

export const PRICING_META = {
  title: "Pricing | NameIt!",
  description: "Prices for NameIt! coins, extra player seats and NameIt! Pro, in US dollars and Nigerian naira.",
};

export const PRICING_INTRO =
  "NameIt! is free to play. These are the optional purchases. Payments in Nigerian naira are processed by Paystack, and international card payments are processed by Bachs. Applicable taxes or payment fees are shown at checkout where they apply.";
